import type * as ecModels from '../../../models'

import type * as models from './models'

/**
 * Configures the behavior of this plugin
 */
export interface Config<TTypeParams extends ecModels.TypeParams.Constraint> {
  /**
   * Whenever the current list changes, this can be used to also change the
   * current entities. It receives the new list of entities, and the existing
   * lookup of selections by {@link ecModels.Target}, and it should return a
   * lookup __ONLY__ containing instructions for the selections that you want to
   * change
   */
  onChangeInCurrentList?: (
    entities: readonly TTypeParams['entity'][],
    currentSelections: Readonly<
      Partial<Record<ecModels.Target, readonly ecModels.EntityId[]>>
    >,
  ) => Partial<Record<ecModels.Target, models.Instruction>>
}
export namespace Config {
  /**
   * Returns a complete {@link Config} from the given {@link Options}
   */
  export function from<TTypeParams extends ecModels.TypeParams.Constraint>(
    config: Readonly<Config.Options<TTypeParams>> | undefined,
  ): Config<TTypeParams> {
    return { ...config }
  }

  /**
   * More flexible version of {@link Config} which allows some properties to be
   * omitted
   *
   * @see {@link Config.from}
   */
  export type Options<TTypeParams extends ecModels.TypeParams.Constraint> =
    Partial<Config<TTypeParams>>
}
